import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { map } from 'rxjs/operators';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { PincodeComponent } from './pages/pincode/pincode.component';
import { DownloadComponent } from './pages/download/download.component';
import { DownloadGuard } from './guards/download.guard';
import { AdminGuard } from './guards/admin.guard';
import { UploadGuard } from './guards/upload.guard';
import { UploadComponent } from './pages/upload/upload.component';

const RedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  return authService.authenticatedUser$
    .pipe(
      map(user => {

        if (user?.canDownload) {
          return router.parseUrl('/download');
        }

        if (user?.canUpload) {
          return router.parseUrl('/upload');
        }

        return true;
      })
    )
};

export const routes: Routes = [
  { path: '', component: ForbiddenComponent, canActivate: [RedirectGuard]},
  { path: 'validate/:uniqueToken', component: PincodeComponent },
  { path: 'validate/:uniqueToken/:language', component: PincodeComponent },
  { path: 'download', component: DownloadComponent, canActivate: [DownloadGuard, AdminGuard]},
  { path: 'upload', component: UploadComponent, canActivate: [UploadGuard, AdminGuard]},
  { path: 'forbidden', component: ForbiddenComponent },
];
